const ALLOWED_ATTACHMENT_EXTENSIONS = new Set([
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'heic',
  'heif',
  'pdf',
  'txt',
  'md',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
]);

const ALLOWED_ATTACHMENT_MIME_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/heic',
  'image/heif',
  'application/pdf',
  'text/plain',
  'text/markdown',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
]);

export const ATTACHMENT_ACCEPT_ATTR = 'image/*,.pdf,.txt,.md,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.heic,.heif';
export const MAX_ATTACHMENT_BYTES = 20 * 1024 * 1024; // 20 MB per file

function getFileExt(name = '') {
  const parts = String(name).toLowerCase().split('.');
  if (parts.length < 2) return '';
  return parts.pop() || '';
}

function formatMb(bytes) {
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function validateAttachmentFile(file, maxBytes = MAX_ATTACHMENT_BYTES) {
  if (!file) return { ok: false, reason: 'Missing file.' };

  const ext = getFileExt(file.name || '');
  const type = String(file.type || '').toLowerCase();
  const extAllowed = ALLOWED_ATTACHMENT_EXTENSIONS.has(ext);
  const mimeAllowed = ALLOWED_ATTACHMENT_MIME_TYPES.has(type);
  const imageWildcardAllowed = type.startsWith('image/');
  const typeAllowed = extAllowed || mimeAllowed || imageWildcardAllowed;

  if (!typeAllowed) {
    return {
      ok: false,
      reason: `Unsupported file type for "${file.name}".`,
    };
  }

  if (Number(file.size || 0) > maxBytes) {
    return {
      ok: false,
      reason: `"${file.name}" is ${formatMb(file.size || 0)}. Max is ${formatMb(maxBytes)}.`,
    };
  }

  return { ok: true };
}
